import request from '@/utils/request'

export interface WarrantyPeriod {
  id: number
  code: string
  name: string
  durationMonths: number
  isActive: boolean
  sortOrder: number
  metadataJson?: any
  createdAt: Date
  updatedAt: Date
}

export const listWarrantyPeriods = (includeInactive = false) =>
  request({
    url: '/warranty-periods',
    method: 'get',
    params: { includeInactive }
  })

export const getWarrantyPeriodById = (id: number) =>
  request({
    url: `/warranty-periods/${id}`,
    method: 'get'
  })

export const createWarrantyPeriod = (data: {
  code: string
  name: string
  durationMonths: number
  isActive?: boolean
  sortOrder?: number
}) =>
  request({
    url: '/warranty-periods',
    method: 'post',
    data
  })

export const updateWarrantyPeriod = (id: number, data: {
  name?: string
  durationMonths?: number
  isActive?: boolean
  sortOrder?: number
}) =>
  request({
    url: `/warranty-periods/${id}`,
    method: 'put',
    data
  })

export const deleteWarrantyPeriod = (id: number) =>
  request({
    url: `/warranty-periods/${id}`,
    method: 'delete'
  })
